import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ApiEngine from "../../util/ApiEngine.js";
import {
    ApiKey,
    ApiUrl,
    SessionKey,
    WebUrl
} from "../../util/Constant";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import SecureLS from "secure-ls";
import LiveChatModal from '../../components/custom/LiveChatModal';
import {
    setDisplayCommunicationChannel,
    setDailyChecking,
    setUnreadNotification,
} from "../../redux/AppAction";

/**
 * Author: -
 */
const BottomNav = React.forwardRef((props, ref) => {
    const {
        data,
    } = props;
    const { t, i18n } = useTranslation();
    const _dispatch = useDispatch();
    const ls = new SecureLS();
    const _history = useHistory();
    const location = useLocation();
    const { isLoggedIn } = useSelector((state) => state.authState);
    const _userData = useSelector((state) => state.authState.userData);
    let isNonSeamlessGameExist = useSelector((state) => state.appState.isNonSeamlessGameExist);
    let unreadNotification = useSelector((state) => state.appState.unreadNotification);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let isPendingDailyCheckIn = useSelector((state) => state.appState.isCheckedIn);
    const [isDisplayFund, setIsDisplayFund] = useState(false);

    const newBottomNavList = [
        {
            title: t("HOME"),
            icon: "/img/ug/bottommenu/home.svg",
            url: WebUrl._URL_MAIN,
            requiredAuth: false,
            onlyNoAuth: false,
            isNotification: false,
            isNotificationCount: 0
        },
        {
            title: t("CHECK_IN"),
            icon: "/img/ug/bottommenu/daily-check-in.svg",
            url: WebUrl._URL_DAILY_CHECK_IN,
            requiredAuth: true,
            onlyNoAuth: false,
            isNotification: isPendingDailyCheckIn,
            isNotificationCount: 0
        },
        {
            title: t("PROMOTION"),
            icon: "/img/ug/bottommenu/promotion.svg",
            url: WebUrl._URL_PROMOTION,
            requiredAuth: false,
            onlyNoAuth: true,
            isNotification: false,
            isNotificationCount: 0
        },
        {
            title: t("FUND"),
            icon: "/img/ug/bottommenu/fund.svg",
            url: "",
            requiredAuth: true,
            onlyNoAuth: false,
            isNotification: false,
            isNotificationCount: 0,
            isIconTransfer: true,
        },
        {
            title: t("MAIL"),
            icon: "/img/ug/bottommenu/mail.svg",
            url: WebUrl._URL_NOTIFICATION,
            requiredAuth: true,
            onlyNoAuth: false,
            isNotification: unreadNotification > 0 ? true : false,
            isNotificationCount: unreadNotification
        },
        {
            title: t("LIVE_CHAT"),
            icon: "/img/ug/bottommenu/live-chat.svg",
            url: "",
            requiredAuth: false,
            onlyNoAuth: false,
            isNotification: false,
            isNotificationCount: 0,
            isLiveChat: true
        },
    ]


    const transcationList = [{
        title: t("DEPOSIT"),
      url: WebUrl._URL_DEPOSIT,
      isDisplay: true
    },
    {
      title: t("WITHDRAWAL"),
      url: WebUrl._URL_WITHDRAWAL,
      isDisplay: _userData && _userData.isBlockWithdraw ? false : true,
    },
    //{
    //    title: t("TRANSFER"),
    //    url: WebUrl._URL_TRANSFER,
    //    isDisplay: isNonSeamlessGameExist,
    //},
    {
        title: t("STATEMENT"),
      url: WebUrl._URL_STATEMENT,
      isDisplay: true
    },
    ]


  const notificationInterval = useRef(null);


    //useEffect
    useEffect(() => {
      if (isLoggedIn) {
        checkDailyCheckin();
        clearInterval(notificationInterval.current);
        notificationInterval.current = setInterval(getUnreadNotification, 30000);
      } else {
        clearInterval(notificationInterval.current);
        _dispatch(setDailyChecking(false));
      }
      return () => clearInterval(notificationInterval.current);
    }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      clearInterval(notificationInterval.current);
      notificationInterval.current = setInterval(getUnreadNotification, 30000);
    } else {
      clearInterval(notificationInterval.current);
    }
    return () => clearInterval(notificationInterval.current);
  }, [localStorage.getItem(SessionKey._LANGUAGE)]);
    //check daily check in
    async function checkDailyCheckin() {
        let responseJson = await ApiEngine.get(ApiUrl._API_CHECK_TODAY_CHECK_IN_STATUS);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            var status = responseJson[ApiKey._API_DATA_KEY];
            if (status == false) {
                _dispatch(setDailyChecking(true));
            }
        }
    }

    // check unread notification 
    async function getUnreadNotification() {
      var responseJson = await ApiEngine.get(
        ApiUrl._API_GET_UNREAD_NOTIFICATION_LIST + "?languageCode=" +
        (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
          localStorage.getItem(SessionKey._LANGUAGE) : 'id'));

      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        _dispatch(setUnreadNotification(responseJson[ApiKey._API_DATA_KEY]));
      } else {
        _dispatch(setUnreadNotification(0));
      }
  }

    const handleOnClick = async (item) => {
        if (item.isIconTransfer) {
            setIsDisplayFund(!isDisplayFund);
        } else {
            if (item.isLiveChat) {
                _dispatch(setDisplayCommunicationChannel(true));
            }
            else {
                _history.push(item.url)
            }
        }
    }

    return (
        <> {isDisplayFund &&
        <div className="fund-container">{
            transcationList.filter(j => j.isDisplay).map((item2, index) => {
                    return (
                        <div key={"fund-container_" + index}>
                            <div className="title" onClick={() => { _history.push(item2.url); setIsDisplayFund(!isDisplayFund); }}>
                                {item2.title}
                            </div>
                        </div>
                    )
                })
            }
            </div>
        }
            <div id="new-bottom-nav">
                <div className="new-bottom-nav-container">
                    {newBottomNavList && newBottomNavList.length > 0 && newBottomNavList.filter(x => !isLoggedIn ? !x.requiredAuth || x.onlyNoAuth : !x.onlyNoAuth).map((item, index) => {
                        return (
                          <div key={"new-bottom-nav-item_" + index} className="new-bottom-nav-item" onClick={() => { handleOnClick(item) }}>
                                <div className={item.isIconTransfer ? "image-container icon-transfer" : "image-container"} style={{ maxHeight:'30px' }}>
                                    <LazyLoadImage src={item.icon} />
                                    {item.isNotification &&
                                        <div className="notification-wrapper">
                                            <div className="notification-count">{item.isNotificationCount > 0 ? item.isNotification : ""}</div>
                                        </div>
                                    }
                                </div>
                                <div className="title">
                                    {item.title}
                                </div>
                            </div>
                        )
                    })
                    }
            </div>
              <LiveChatModal />
            </div>
        </>
    );
});

export default BottomNav;
